

























import type { GetMainMenus, GetServicesServiceNoMainDomainsResponse, Mall, NcpXhrError } from 'ncp-api-supporter';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

import { commerceApi } from '@/api';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

import MallDueDaysSummary from './MallDueDaysSummary.vue';
import MessageSendCount from './MessageSendCount.vue';
import SmsPointSummary from './SmsPointSummary.vue';
import DomainSecurityConnection from './DomainSecurityConnection.vue';
import { AdminState } from '@/types';

const DEFAULT_DOMAIN_SECURITY_INFO: GetServicesServiceNoMainDomainsResponse = {
  domain: '',
  domainExpirationDueDays: null,
  domainExpiredAt: null,
  domainNo: 0,
  domainStatus: 'DISCONNECTED',
  mallNo: 0,
  mobileDomain: null,
  mobileDomainExpirationDueDays: null,
  mobileDomainExpiredAt: null,
  mobileDomainStatus: 'DISCONNECTED',
  mobileSslExpirationDueDays: null,
  mobileSslExpiredAt: null,
  mobileSslStatus: 'UNINSTALLED',
  skinType: 'COMBINE',
  sslExpirationDueDays: null,
  sslExpiredAt: null,
  sslStatus: 'UNINSTALLED',
};

@Component({
  components: {
    CompSelectBox,
    DomainSecurityConnection,
    MallDueDaysSummary,
    MessageSendCount,
    SmsPointSummary,
  },
})
export default class MallStatusBar extends Vue {
  @Prop({ required: true })
  private mainMall!: {
    no: number;
  };

  @Getter('admin', { namespace: 'admin' })
  private admin!: AdminState;

  @State('malls', { namespace: 'mall' })
  private stateMalls!: Mall[];

  @State('menuGroups', { namespace: 'admin' })
  private menuGroups!: GetMainMenus[];

  get malls() {
    return [
      { mallNo: 0, mallName: '쇼핑몰' },
      ...this.stateMalls,
    ];
  }

  @Watch('malls', { immediate: true })
  setMainMallNo() {
    if (this.stateMalls.length === 1 && !this.mainMall.no) {
      this.mainMall.no = this.stateMalls[0].mallNo;
    }
  }

  domainSecurityInfos: GetServicesServiceNoMainDomainsResponse[] = [];

  get domainSecurityInfo() {
    return this.mainMall.no
        ? this.domainSecurityInfos.find(({ mallNo }) => mallNo === this.mainMall.no)
        : DEFAULT_DOMAIN_SECURITY_INFO;
  }

  async created() {
    this.domainSecurityInfos = await this.getDomainSecurityInfos();
  }

  get hasDomainMenuReadAuth() {
    // "도메인/보안서버 관리" 메뉴 읽기권한 있는지 체크. 현재로서는 이렇게 할 수 밖에 없음
    return !!this.menuGroups
      .find(({ name }) => name === '서비스관리')
      ?.menus.find(({ uri }) => uri === '/domain-ssl');
  }

  /**
   * 도메인/보안서버 연결상태 정보 호출
   */
  private async getDomainSecurityInfos() {
    try {
      const { serviceNo } = this.admin;

      const { data } = await commerceApi.getServicesServiceNoMainDomains({
        pathParams: { serviceNo: serviceNo.toString() },
      });

      return data;
    } catch (err) {
      console.error(err);
      const error = err as NcpXhrError

      if (error.data.code !== 'M0001') {
        throw error;
      }

      return [];
    }
  }
}
